import { render } from "./EmpresaVue.vue?vue&type=template&id=5bdcb388&scoped=true"
import script from "./EmpresaVue.vue?vue&type=script&lang=js"
export * from "./EmpresaVue.vue?vue&type=script&lang=js"

import "./EmpresaVue.vue?vue&type=style&index=0&id=5bdcb388&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bdcb388"]])

export default __exports__